import { isFeatureEnabled } from 'owa-feature-flags';

export default function getSupportedQueryAlterationTypes(): string[] {
    const supportedQueryAlterationTypes = ['Suggestion', 'NoResultModification'];

    if (
        isFeatureEnabled('sea-naturalLanguageR') ||
        isFeatureEnabled('sea-trySuggestions') ||
        isFeatureEnabled('sea-trySuggestionsC') ||
        isFeatureEnabled('sea-trySuggestions-always')
    ) {
        supportedQueryAlterationTypes.push('NoRequeryModification');
    }

    if (isFeatureEnabled('sea-modificationQueryAlteration')) {
        supportedQueryAlterationTypes.push('Modification');
    }

    if (isFeatureEnabled('sea-extensionQueryAlteration')) {
        supportedQueryAlterationTypes.push('Extension');
    }

    return supportedQueryAlterationTypes;
}
